module.exports = __webpack_public_path__ + "static/media/Grand-Square-Int-Cam-02-mobile.88af016e.webp";